import axios from "axios";
import get from "lodash/get";

import {store} from "../configureStore";
import {
    loadChartsDataRequestFail,
    loadChartsDataRequestStart,
    loadChartsDataRequestSuccess,
} from '../actions/Statistic';


export const loadChartsData = (shopId, metrics, ts_from, ts_to, period, callback) => {
    return function (dispatch) {
        const instance = axios.create({
            baseURL: process.env.REACT_APP_API_URL,
            
            headers: {
                Authorization: `Bearer  ${store.getState().Auth.authToken}`,
                'Content-Type': 'application/json',
            },
        });

        const requestData = {
            shop_id: shopId,
            metrics,
            ts_from,
            ts_to,
            period,
        };

        dispatch(loadChartsDataRequestStart(requestData));

        instance.post(`analytics/chart_data/`, requestData).then(
            (response) => {
                if (response.data.status === 'ok') {
                    dispatch(loadChartsDataRequestSuccess(response.data.result));
                    callback && callback(response.data.result);
                } else {
                    dispatch(loadChartsDataRequestFail(response.data.errors));
                }
            },
            error => dispatch(loadChartsDataRequestFail(`Errors: ${get(error, 'response.data.errors')}`)),
        );
    }
};
